import React from 'react';
import '../../styles/components/AsperaConnectInstaller.scss';
import { runningWithAsperaMobile } from '../../helpers/transfer';
import { setStorageItem, openInstallMobileApp, supportMobileAppAdvertising, getStorageItem } from '../../helpers/starterHelpers';
import { storageKeys } from '../../constants/constants';
import { language } from '../../services/LanguageService';
import { ImageConnectFlow } from '../../svg/ImageConnectFlow';
import { Modal, Button } from '../Carbon';
import { tracking } from '../../services/TrackingService';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
/**
 * React Component
 *
 * The AsperaMobileInstaller provides the custom mobile flow for launching the app
 * AsperaAppWrapper renders this component.
 *
 * @example
 * ```javascript
 * <AsperaMobileInstaller />
 * ```
 */
export class AsperaMobileInstaller extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            promptVisible: false,
        };
        this.subManager = new SubManager();
        this.webViewCallback = () => { };
        this.openMobileApp = () => {
            openInstallMobileApp(true);
        };
        this.installMobileApp = () => {
            openInstallMobileApp(false);
        };
        this.closeMobileAppPrompt = () => {
            setStorageItem(storageKeys.ignoreMobilePrompt, 'TRUE');
            this.setState({ promptVisible: false });
            this.webViewCallback();
        };
    }
    get mobileScreen() {
        return (React.createElement("div", { className: "aspera-connect-installer--mobile-modal" },
            React.createElement(Modal, { open: true, size: "sm", passiveModal: true, onRequestClose: this.closeMobileAppPrompt, preventCloseOnClickOutside: true },
                React.createElement("div", { className: "image-area" },
                    React.createElement(ImageConnectFlow, null)),
                React.createElement("div", { className: "text-area" },
                    React.createElement("div", { className: "text-area--heading" }, language.get('transferSystem.welcomeMobile')),
                    React.createElement("div", { className: "text-area--info" }, language.get('transferSystem.welcomeMobileText')),
                    React.createElement("div", { className: "text-area--multi-buttons" },
                        React.createElement(Button, { kind: "primary", className: "text-area--multi-action", size: "md", onClick: this.openMobileApp }, language.get('transferSystem.launchApp')),
                        React.createElement(Button, { kind: "tertiary", className: "text-area--multi-action", size: "md", onClick: this.installMobileApp }, language.get('transferSystem.downloadApp'))),
                    React.createElement("div", { className: "text-area--multi-buttons" },
                        React.createElement(Button, { kind: "ghost", className: "text-area--multi-action", size: "md", onClick: this.closeMobileAppPrompt }, language.get('transferSystem.useWeb')))))));
    }
    componentDidMount() {
        this.subManager.setSubscription(tracking.mobilePromptLauncher.subscribe({
            next: data => {
                if (runningWithAsperaMobile() || !supportMobileAppAdvertising() || getStorageItem(storageKeys.ignoreMobilePrompt)) {
                    data.callback();
                    this.setState({ promptVisible: false });
                }
                else {
                    this.webViewCallback = data.callback;
                    this.setState({ promptVisible: true });
                }
            },
            error: error => {
                new AsperaError('AsperaMobileInstaller: unable to watch for mobile prompt', error);
                this.setState({ promptVisible: false });
            },
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { promptVisible } = this.state;
        const { className } = this.props;
        if (promptVisible) {
            return React.createElement("div", { className: `aspera-connect-installer aspera-mobile-installer ${className ? className : ''}`, "data-auto": "mobile-installer" }, this.mobileScreen);
        }
        return null;
    }
}
